import React, { useMemo } from "react";
import { Chip, Divider, Typography } from "@mui/material";

import {
  useGetLeads,
  usePutLeadStage,
} from "../../hooks/react-query/useSalesData";
import {
  LEAD_STAGE_LABELS,
  QUOTE_STAGE_LABELS,
} from "../../constants/salesStages";

import KanbanBoard from "./KanbanBoard";
import LeadCard from "./LeadCard";
import SalesEmpty from "./SalesEmpty";
import { StyledHubCardStack, StyledLabelBox } from "./styles";

export const StartComponent = ({ column, isLead }) => {
  const stages = isLead ? LEAD_STAGE_LABELS : QUOTE_STAGE_LABELS;
  const stage = stages.find((l) => l.id === Number(column.id));
  return (
    <>
      <StyledHubCardStack>
        <StyledLabelBox color={stage?.color} />
        <Typography variant="caption">{stage?.label}</Typography>
        <Chip label={column?.elements?.length} />
      </StyledHubCardStack>
      <Divider orientation="horizontal" flexItem />
    </>
  );
};

const SalesLeadsKanban = () => {
  const { data, isLoading } = useGetLeads();
  const { mutate: moveStage } = usePutLeadStage();

  const totalItems = useMemo(
    () => (data || []).reduce((sum, col) => sum + col.elements.length, 0),
    [data],
  );

  if (!isLoading && !totalItems) return <SalesEmpty type="lead" />;

  return (
    <KanbanBoard
      columns={data || []}
      CardComponent={LeadCard}
      onStageChange={moveStage}
      isLoading={isLoading}
      StartComponent={({ ...rest }) => <StartComponent {...rest} isLead />}
    />
  );
};

export default SalesLeadsKanban;
